import { getReq } from '../service/API'
import useSWR from 'swr'
import { getSite_endpoint } from '../service/api-gateway'

export const useSite = (siteId: string, suspense = true) => {
  const endpoint = siteId ? getSite_endpoint(siteId) : null
  const { data, error } = useSWR(endpoint, getReq, { suspense: suspense })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}
